import React from "react";
import { Link } from "react-router-dom";

import icon1 from "../assets/images/icons/color-swatches.svg"
import icon2 from "../assets/images/icons/decent-work-and-economic-growth.svg"
import icon3 from "../assets/images/icons/flip-horizontal-arrow-1.svg"
import icon4 from "../assets/images/icons/layers-1.svg"
import icon5 from "../assets/images/icons/pictures-folder-memories.svg"
import icon6 from "../assets/images/icons/production-belt-time.svg"

import {FiHexagon} from '../assets/icons/vander'
import {FiCamera} from "../assets/icons/vander"

export default function Features({title,logo}){
    const featuresData =[
        {
            image:icon1,
            title:'Grow Your Business',
            desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
          },
          {
              image:icon2,
              title:'Drive More Sales',
              desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
            },
             {
            image:icon3,
            title:'Handled By Expert',
            desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
          }, {
              image:icon4,
              title:'Discussion For Idea',
              desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
            },
            {
              image:icon5,
              title:'Increase Conversion',
              desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
            },
            {
              image:icon6,
              title:'Sales Growth Idea',
              desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
            },

    ]
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
            {title === false ? "" : 
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl font-medium">My Tech Stack</h3>

                    <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">Mastering the latest technologies to drive exceptional results and enhance user engagement.</p>
                </div>
            }

            <div className="container-fluid relative mt-16">
                <div className="grid lg:grid-cols-8 md:grid-cols-5 sm:grid-cols-4 grid-cols-3 justify-center gap-6">
                    {logo.map((item,index)=>{
                        return(
                        <div>
                            <div className="picture-item p-1" data-groups='["branding"]' key={index}>
                                <div className="group relative block overflow-hidden rounded-xl duration-500">
                                    <Link to=""   className="lightbox duration-500 group-hover:scale-105" title="">
                                        <img src={item.logo} className="" alt=""/>
                                    </Link>
                                    <div className="absolute -bottom-52 group-hover:bottom-2 start-2 end-2 duration-500 bg-white dark:bg-slate-900 p-4 rounded-xl shadow dark:shadow-gray-800">
                                        <Link to="/portfolio-detail-two" className="hover:text-orange-500 text-[15px] duration-500 font-medium">{item.title}</Link>
                                        <h6 className="text-slate-400 dark:text-white/60">{item.name}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                </div>
            </div>

             
            </div>
        </>
    )
}